import React from 'react'
import {BootstrapTable, TableHeaderColumn} from 'react-bootstrap-table';
import moment from 'moment'

import NavLink from '../Routes/NavLink'

import { properties } from '../../core/controllers/Properties'
import { multiTaskerManager } from '../../core/controllers/MultiTaskerManager'

export default class PropertyList extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            properties: null
        };

        this.lastSortID = 0;
        this.index = 0;
    }

    componentDidMount() {
        var self = this;
        properties.getProperties(this.lastSortID, function(response) {
            self.setState({properties: response.data})
        });
        this.setupToolTips();
    }

    componentWillUpdate(nextProps, nextState) {
        if(this.lastSortID != nextProps.sortID) {
            this.lastSortID = nextProps.sortID;
            properties.getProperties(this.lastSortID, function(response) {
                self.setState({properties: response.data})
            });
        }
    }

    formatIndexColumn(cell, row) {
        ++this.index;
        return this.index;
    }

    formatActionOptions(cell, row) {
        return (
            <span>
            <NavLink to={/properties/ + row.property_id}><i class="tooltip_custom pull-right fa fa-pencil-square-o">
                <span data-toggle="tooltip" data-placement="bottom" data-original-title="Edit Property" title="" class=""></span>
                </i>
            </NavLink>
            { row.pending != undefined && (
                <span class="important-small-blue"></span>
            )}
            </span>
        )
    }

    formatUnits(cell, row) {
        return (
            <span>{row.units_tally}</span>
        )
    }

    formatDate(cell, row) {
        if(cell) {
            return moment(cell).format('MMMM Do YYYY');
        } else {
            return 'Not Set';
        }
    }

    setupToolTips() {
        setTimeout(() => {
            jQuery(".tooltip_custom").hover(function() {
				jQuery(this).find('[data-toggle="tooltip"]').tooltip('show');
			}, function() {
				jQuery(this).find('[data-toggle="tooltip"]').tooltip('hide');
			}
		    );
        }, 500);
	}

    flattenObject(ob) {
        var toReturn = {};
        for (var i in ob) {
            if (!ob.hasOwnProperty(i)) continue;
            if ((typeof ob[i]) == 'object') {
                var flatObject = this.flattenObject(ob[i]);
                for (var x in flatObject) {
                    if (!flatObject.hasOwnProperty(x)) continue;
                    toReturn[x] = flatObject[x];
                }
            } else {
                toReturn[i] = ob[i];
            }
        }
        return toReturn;
    }

    render(){
        var self = this;
        var properties = this.state.properties;
        if(properties != null) {
            properties = properties.map(function(property) {
                return self.flattenObject(property);
            });
        }

        return (
            <div class="content" >
                {properties != null ? (
                    <BootstrapTable data={properties} version='4' striped search pagination>
                        <TableHeaderColumn dataField='property_id' width="50" dataFormat={this.formatIndexColumn} hidden={window.matchMedia('(max-width: 992px)').matches} isKey={ true }></TableHeaderColumn>
                        <TableHeaderColumn dataField='property_name' dataSort={ true }>Name</TableHeaderColumn>
                        <TableHeaderColumn dataField='property_type' dataSort={ true }>Type</TableHeaderColumn>
                        <TableHeaderColumn dataField='property_address' dataSort={ true }>Address</TableHeaderColumn>
                        <TableHeaderColumn dataField='property_city' dataSort={ true }>City</TableHeaderColumn>
                        <TableHeaderColumn dataField='property_state' dataSort={ true }>State</TableHeaderColumn>
                        <TableHeaderColumn dataField='property_zip' dataSort={ true }>Zipcode</TableHeaderColumn>
                        <TableHeaderColumn dataFormat={this.formatUnits} dataSort={ false }>Units</TableHeaderColumn>
                        <TableHeaderColumn dataField='created_at' dataFormat={this.formatDate} dataSort={ true }>Date Created</TableHeaderColumn>
                        <TableHeaderColumn dataAlign='center' dataFormat={this.formatActionOptions.bind(this)}></TableHeaderColumn>
                    </BootstrapTable>
                ) : (
                    <div>
                        <p>No properties found.  Try adding some.</p>
                        <div class="col-md-12" style={{backgroundImage: "url('/assets/img/properties.png')", backgroundRepeat: 'no-repeat', backgroundPosition: 'bottom', backgroundSize: '55%', minHeight: '560px'}}></div>
                    </div>
                )}
                <div class="content">
                    <NavLink to={"/properties/new"}>
                        <button type="button" id="add-tenant" data-loading-text="Loading..." class="add-tenant btn btn-info btn-fill pull-right" autoComplete="off">
                            Add Property
                        </button>
                        <div class="clearfix"></div>
                    </NavLink>
                </div>
            </div>
        )
    }
};



// WEBPACK FOOTER //
// app/components/Properties/PropertiesList.jsx